import React, { FC } from 'react'
import { List, Datagrid, TextField, ListProps } from 'react-admin'

import { Toolbar } from 'components/List'
import { FilterApp } from 'components/FilterApp'

export const ListLessons: FC<ListProps> = (props: any) => {
  const { staticContext, ...rest } = props

  return (
    <List
      {...rest}
      actions={
        <Toolbar>
          <FilterApp filterLesson filterCourse={false} filterPerson={false} filterUser={false}/>
        </Toolbar>
      }
      data-testid="list"
    >
      <Datagrid rowClick="edit">
        <TextField label="#" source="id" />
        <TextField label="Ordem" source="order" />
        <TextField label="Título" source="title" />
        <TextField label="Tipo" source="type" />
        <TextField label="Slug" source="slug" />
        <TextField label="Sumário" source="summary" />
        <TextField label="Descrição" source="description" />
      </Datagrid>
    </List>
  )
}
